import { legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { useEditorSession } from '../../EditorSessionContext'
import { useEditorSurface } from '../../EditorSurfaceContext'
import { delegatedSettingChange, useSettingSelectGroups } from './SettingSelectState'

// Rules fieldset (legacy "advanced"). forbid/fold/freeze/hide are checkbox +
// dropdown pairs; option values/labels are the legacy new-form contract 1:1
// (searchpg2012 reference DOM, 2026-07-17). The "Messages"/"Everything"
// options exist only on msg desks (m31 hides option[value=2]+next otherwise).
// is_one_parent / is_force_pins live in the Protection tab ("( and child )")
// and is_to_remove in the Show tab ("( and delete )"), matching legacy.
const comboRows = [
  { check: 'is_forbid', combo: 'is_forbid_combo', label: 'Ban:' },
  { check: 'is_fold', combo: 'is_fold_combo', label: 'Fold:' },
  { check: 'is_freeze', combo: 'is_freeze_combo', label: 'To freeze:' },
  { check: 'is_hide', combo: 'is_hide_combo', label: 'Hide:' },
] as const

const ruleSelectGroups = comboRows.map(row => ({ master: row.check, combos: [row.combo] }))

const checkRows: Array<[string, string]> = [
  ['is_hide_parents', 'Hide parents'],
  ['is_full_tree', 'Show All Tree'],
  ['is_left_menu', 'Menu on the left'],
  ['is_super', 'Super msg'],
  ['is_hidden', 'Hidden'],
]

export function RulesPanel() {
  const { skin, registeredUsersRule = 'optional' } = useEditorSurface()
  const classes = skin.settings
  const { isEnabled, selectValue } = useSettingSelectGroups(ruleSelectGroups)
  // §0.16: message-only options come from the shared editor-session identity
  // (fail-closed), never from the independently synchronized rough model.
  const editorSession = useEditorSession()
  const isMsg = editorSession.isMsg === true
  return (
    <fieldset {...legacyContractDataAttrs('editor.settings.advanced')} className={classes.panel}>
      <legend className={classes.legend}>Rules</legend>
      {comboRows.map(row => (
        <div key={row.check} className={classes.row}>
          <label className={classes.rowCheck}>
            <input type="checkbox" name={row.check} value="1" checked={isEnabled(row.check)} onChange={delegatedSettingChange} />
            {row.label}
          </label>
          <select name={row.combo} className={classes.combo} disabled={!isEnabled(row.check)} value={selectValue(row.combo)} onChange={delegatedSettingChange}>
            <option value="1">Answers</option>
            {isMsg ? <option value="2">Messages</option> : null}
            {isMsg ? <option value="3">Everything</option> : null}
          </select>
        </div>
      ))}
      {checkRows.map(([name, label]) => (
        <label key={name} className={classes.check}>
          <input type="checkbox" name={name} value="1" />
          {label}
        </label>
      ))}
      {/* REGISTERED USERS (docs task §5): members-gated creation is a
          named-message rule. Answers cannot be authenticated as membership
          roots, so their Configure UI must not offer it. */}
      {isMsg && registeredUsersRule !== 'forced-hidden' ? (
        <label className={classes.check}>
          <input type="checkbox" name="is_reg_users" value="1" />
          Registered users only
        </label>
      ) : null}
    </fieldset>
  )
}
